export default __webpack_public_path__ + "static/media/step4.c066ae05.webp";